import { StyleSheet } from "@react-pdf/renderer"
import { colors } from "../styles"

export const stylesPDF = StyleSheet.create({
  page: {
    padding: 10,
    paddingBottom: 12,
    fontFamily: "Source Sans Pro",
  },
  section: {
    flexGrow: 1,
    marginTop: 10,
    gap: 2,
  },
  sectionTitle: {
    fontSize: 11,
    fontWeight: 700,
    paddingBottom: 8,
    lineHeight: 1.25,
    color: colors.gray[8],
  },
  noRuns: {
    fontSize: 8,
    fontWeight: 600,
    paddingTop: 8,
    color: colors.gray[7],
  },
  chartContainer: {
    borderRadius: 4,
    border: `1px solid #CCD1D6`,
    marginBottom: 8,
    width: "100%",
    height: "auto",
  },
  chart: {
    paddingTop: 6,
    paddingBottom: 6,
    paddingRight: 6,
    paddingLeft: 4,
  },
  chartTitleContainer: {
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    backgroundColor: "#F2F5F8",
    paddingLeft: 8,
    paddingRight: 8,
    paddingBottom: 8,
    paddingTop: 8,
  },
  chartTitleText: {
    color: "#3B454F",
    textAlign: "left",
    fontSize: 8,
    fontWeight: 700,
  },
})
